<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>用车申请</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form
        :inline="true"
        :model="searchFrom"
        ref="searchFrom"
        class="demo-form-inline"
        label-width="90px"
        size="mini"
      >
        <div class="inpBox">
          <el-form-item label="创建日期:" prop="startTime">
            <el-date-picker
              v-model="searchFrom.startTime"
              size="mini"
              style="width: 190px"
              placeholder="选择日期"
              type="datetime"
            ></el-date-picker>&nbsp;-&nbsp;&nbsp;
            <el-date-picker
              v-model="searchFrom.endTime"
              size="mini"
              style="width: 190px"
              placeholder="选择日期"
              type="datetime"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="工作类型:" prop="workType">
            <el-select v-model="searchFrom.workType" placeholder="请选择">
              <el-option
                v-for="(item, index) in jobTypeOptions"
                :key="index"
                :label="item.showName"
                :value="item.itemNo"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车型:" prop="vhcTypeId">
            <el-select v-model="searchFrom.vhcTypeId" placeholder="请选择">
              <el-option
                v-for="item in carTypeOptions"
                :key="item.vhcTypeId"
                :label="item.vhcTypeName"
                :value="item.vhcTypeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态:" prop="applyFlg">
            <el-select v-model="searchFrom.applyFlg" placeholder="请选择">
              <el-option
                v-for="(item, index) in statusOptions"
                :key="index"
                :label="item.showName"
                :disabled="item.itemNo =='4'"
                :value="item.itemNo"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchClick" btnCode="00MP001B001" v-if="btnFlg[0]">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chongZhiClick" btnCode="00MP001B002" v-if="btnFlg[1]">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addBtnClick" btnCode="00MP001B003" v-if="btnFlg[2]">新增</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }" v-loading='tabLoading'>
      <el-table
        :data="tableList"
        ref="tableList"
        border
        bordersize="mini"
        height="100%"
        style="width: 100%; margin-top: 10px"
        center
        @row-click="handleRowClick"
        @current-change="handleTabCurrentChange"
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        :header-row-style="{ height: '45px' }"
        :row-style="{ height: '35px' }"
        highlight-current-row
      >
        <!-- <el-table-column type="selection" width="55" align="center" ></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="customerName" label="操作" width="150" align="center" :formatter="formatterRowEmpty">
          <template slot-scope="scope"><div>
            <el-button @click="changeDataClick(scope.row)" v-if="scope.row.apply_flg == '1' && btnFlg[3]" type="text" size="small" btnCode="00MP001B004">修改</el-button>
            <el-button @click="revokeClick(scope.row)" v-if="scope.row.apply_flg == '1' && btnFlg[4]" type="text" size="small" btnCode="00MP001B005">删除</el-button>
            <el-button @click="detailsClick(scope.row)" v-if="btnFlg[5]" btnCode="00MP001B006" type="text" size="small"  >详情</el-button>
          </div></template>
        </el-table-column>
        <el-table-column prop="apply_no" label="申请单号" align="center" width="230" ></el-table-column>
        <el-table-column prop="apply_flg_name" label="状态" align="center" width="100" ></el-table-column>
        <el-table-column prop="name" label="用车时间" align="center" width="330" >
          <template slot-scope="scope"><div>
            <span>{{scope.row.apply_start_time | dateFormat}} 至 {{scope.row.apply_end_time | dateFormat}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="vhc_type_name" label="车型" align="center" width="100" ></el-table-column>
        <el-table-column prop="tonnage_model" label="吨位/规格" align="center" width="100" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="vhc_num" label="车数" align="center" ></el-table-column>
        <el-table-column prop="" label="单价" align="center" width="100" >
          <template slot-scope="scope"><div>
            <span>{{scope.row.unit_price + '/' + scope.row.pricing_method}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="work_type_name" label="工作类型" align="center" width="150" ></el-table-column>
        <el-table-column prop="work_content" label="工作内容" align="center" width="160"></el-table-column>
        <el-table-column prop="vhcapply_address" label="工作地点" align="center" width="150" ></el-table-column>
        <el-table-column prop="department_name" label="用车部门" align="center" width="180" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="subsidiary_department_name" label="用车单位" align="center" width="150"></el-table-column>
        <el-table-column prop="apply_user" label="用车人" align="center" ></el-table-column>
        <el-table-column prop="user_mobile" label="联系电话" align="center" width="120"></el-table-column>
        <el-table-column prop="create_user_name" label="创建人" align="center" ></el-table-column>
        <el-table-column prop="" label="创建时间" align="center" width="180" >
          <template slot-scope="scope"><div>
            <span>{{scope.row.create_time | dateFormat}}</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center" width="200" :formatter="formatterRowEmpty"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[10, 25, 50, 100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 添加/编辑 -->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="addAndChangeMark"
    @close="addCloseDialog('addAndChangeFrom')"
    width="1100px"
    center>
      <div v-loading='addAndChangeLoading'>
      <div class="bigBox">
        <el-form
          :model="addAndChangeFrom"
          :rules="rules"
          :validate-on-rule-change = "false"
          :inline="true"
          ref="addAndChangeFrom"
          class="demo-form-inline"
          label-width="110px" size="mini">
        <div class="" style="">
          <div style="margin:20px 0 10px 0 ;">
            <el-form-item label="用车时间:" required>
              <el-col :span="12">
                <el-form-item prop="startTime">
                  <el-date-picker
                    :validate-event = "false"
                    v-model="addAndChangeFrom.startTime"
                    size="mini"
                    style="width: 190px"
                    placeholder="选择日期"
                    type="datetime"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col class="line" :span="2">~</el-col>
              <el-col :span="6">
                <el-form-item prop="endTime">
                  <el-date-picker
                    :validate-event = "false"
                    v-model="addAndChangeFrom.endTime"
                    size="mini"
                    style="width: 190px"
                    placeholder="选择日期"
                    type="datetime"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="用车单位:" style="margin-left:10px;" required>
              <el-col :span="12">
                <el-form-item prop="carUnit">
                  <el-input placeholder="" maxlength=""  v-model.trim="addAndChangeFrom.carUnitName" disabled style="width:120px;"></el-input>
                  <!-- <el-select v-model="addAndChangeFrom.carUnit" placeholder="请选择" @change="carUnitChange(addAndChangeFrom.carUnit)" style="width:120px;">
                    <el-option
                      v-for="item in carUnitOptions"
                      :key="item.orgCode"
                      :label="item.orgName"
                      :value="item.orgCode">
                    </el-option>
                  </el-select> -->
                </el-form-item>
              </el-col>

              <el-col :span="11">
                <el-form-item prop="carArea">
                  <el-input placeholder="" maxlength=""  v-model.trim="addAndChangeFrom.carAreaName" disabled style="width:120px;"></el-input>
                  <!-- <el-select v-model="addAndChangeFrom.carArea" @change="carAreaChange(addAndChangeFrom.carArea)" placeholder="请选择" style="width:150px;">
                    <el-option
                      v-for="item in carAreaOptions"
                      :key="item.orgCode"
                      :label="item.orgName"
                      :value="item.orgCode">
                    </el-option>
                  </el-select> -->
                </el-form-item>
              </el-col>
            </el-form-item>
          </div>
          <hr>
          <div style="margin:20px 0 10px 0 ;">
             <el-form-item label="申请车型:" required>
              <el-col :span="10">
                <el-form-item prop="applicationMode">
                  <el-select v-model="addAndChangeFrom.applicationMode" @change="applicationModeChange(addAndChangeFrom.applicationMode)" placeholder="请选择" style="width:120px;">
                    <el-option
                      v-for="item in carTypeOptions"
                      :key="item.vhcTypeId"
                      :label="item.vhcTypeName"
                      :value="item.vhcTypeId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item prop="attribute">
                  <el-select v-model="addAndChangeFrom.attribute" placeholder="请选择" @change="attributeChange(addAndChangeFrom.attribute)" style="width:150px;">
                    <el-option
                      v-for="item in attributeOptions"
                      :key="item.tonnageModelId"
                      :label="item.tonnageModel"
                      :value="item.tonnageModelId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item label="车数:" prop="carNum" style="">
              <el-input placeholder="" maxlength=""  v-model.trim="addAndChangeFrom.carNum" style="width:120px;"></el-input>
            </el-form-item>
            <el-form-item label="单价:" prop="monovalent" style="">
              <el-select v-model="addAndChangeFrom.monovalent" @change="monovalentChange(addAndChangeFrom.monovalent)" placeholder="请选择" style="width:160px;">
                <el-option
                  v-for="item in monovalentOptions"
                  :key="item.unitPrice + '/' + item.pricingMethodName"
                  :label="item.unitPrice + '/' + item.pricingMethodName"
                  :value="item.unitPrice + '/' + item.pricingMethodName">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <hr>
          <div style="margin:20px 0 10px 0 ;">
            <el-form-item label="工作类型:" prop="jobType" style="" >
              <el-select v-model="addAndChangeFrom.jobType" placeholder="请选择" style="width:150px;">
                <el-option
                  v-for="(item,index) in jobTypeOptions"
                  :key="index"
                  :label="item.showName"
                  :value="item.itemNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="工作内容:" prop="jobContent" style="" >
              <el-input placeholder="" maxlength=""  v-model.trim="addAndChangeFrom.jobContent" style="width:208px;"></el-input>
            </el-form-item>
            <el-form-item label="用车地点:" prop="vehicleLocation" style="">
              <el-input placeholder="" maxlength=""  v-model.trim="addAndChangeFrom.vehicleLocation" style="width:208px;"></el-input>
            </el-form-item>
          </div>
          <hr>
          <div style="margin:20px 0 10px 0 ;">
            <el-form-item label="用车人:" prop="vehicleOwner" style="" >
              <el-input placeholder="" maxlength=""  v-model.trim="addAndChangeFrom.vehicleOwner" disabled style="width:150px;"></el-input>
            </el-form-item>
            <el-form-item label="联系电话:" prop="telephone" style="">
              <el-input placeholder="" maxlength="11" v-number-input.float="0" disabled v-model.trim="addAndChangeFrom.telephone" style="width:208px;"></el-input>
            </el-form-item>
          </div>
          <hr>
          <div style="margin:20px 0 10px 0 ;">
            <el-form-item label="备注:" prop="remarks" style="" >
              <el-input placeholder="" maxlength=""  v-model.trim="addAndChangeFrom.remarks" style="width:480px;"></el-input>
            </el-form-item>
          </div>
        </div>
        </el-form>
      </div>
      <div  style="width:130px;margin:15px auto;">
         <el-button type="primary" @click="submitForm('addAndChangeFrom')" size='mini'>提交</el-button>
        <el-button @click="resetForm('addAndChangeFrom')" size='mini'>取消</el-button>
      </div>
      </div>
    </el-dialog>
    <!-- 详情 -->
    <div>
      <el-dialog
        :title="title"
        :visible.sync="detailsMark"
        :close-on-click-modal="false"
        width="60%"
        center
        :before-close="handleClose"
      >
      <div v-loading="detailsLoading">
        <div class="addressBox">
          <h4 class="title">
            <span>
              <i class="fa fa-envelope iconFont" aria-hidden="true"></i
              >申请信息
            </span>
          </h4>
          <hr />
          <div class="tongJi">
            <div>
              <span>用车时间：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.apply_start_time | dateFormat}} 至 {{detailsFrom.tVehicleapplyInfo.apply_end_time | dateFormat}}</span>
            </div>
            <div style="margin-left:5%;">
              <span>用车单位：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.department_name}} - {{detailsFrom.tVehicleapplyInfo.subsidiary_department_name}}</span>
            </div>
          </div>
          <div class="tongJi">
            <div>
              <span>车型：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.vhc_type_name}} - {{detailsFrom.tVehicleapplyInfo.tonnage_model}}</span>
            </div>
            <div style="margin-left:5%;">
              <span>车数：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.vhc_num}}</span>
            </div>
            <div style="margin-left:5%;">
              <span>单价：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.unit_price + '/' + detailsFrom.tVehicleapplyInfo.pricing_method}}</span>
            </div>
          </div>
          <div class="tongJi">
            <div>
              <span>工作类型：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.work_type_name}}</span>
            </div>
            <div style="margin-left:5%;">
              <span>工作内容：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.work_content}}</span>
            </div>
            <div style="margin-left:5%;">
              <span>工作地点：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.vhcapply_address}}</span>
            </div>
          </div>
          <div class="tongJi">
            <div>
              <span>用车人：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.apply_user}}</span>
            </div>
            <div style="margin-left:5%;">
              <span>联系电话：</span>
              <span>{{detailsFrom.tVehicleapplyInfo.user_mobile}}</span>
            </div>
          </div>
        </div>

        <div class="addressBox">
          <h4 class="title">
            <span>
              <i class="fa fa-bars iconFont" aria-hidden="true"></i
              >分配信息
            </span>
          </h4>
          <hr />
          <div class="tongJi">
            <el-table
              :data="detailsFrom.detailsTabLias"
              ref=""
              border
              bordersize="mini"
              style="width: 100%; margin-top: 10px"
              center
              :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
              :header-row-style="{ height: '45px' }"
              :row-style="{ height: '35px' }"
              highlight-current-row
            >
              <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
              <el-table-column prop="fleetName" label="车队" align="center"></el-table-column>
              <el-table-column prop="" label="车型" align="center">
                <template ><div>
                  <span>{{detailsFrom.tVehicleapplyInfo.vhc_type_name}} - {{detailsFrom.tVehicleapplyInfo.tonnage_model}}</span>
                </div></template>
              </el-table-column>
              <el-table-column prop="vehicleNum" label="分配车数" align="center"></el-table-column>
              <el-table-column prop="createTime" label="分配时间" align="center">
                <template slot-scope="scope"><div>
                  <span>{{scope.row.createTime | dateFormat}}</span>
                </div></template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="addressBox">
          <h4 class="title">
            <span>
              <i class="fa fa-bars iconFont" aria-hidden="true"></i
              >出车信息
            </span>
          </h4>
          <hr />
          <div class="tongJi">
            <el-table
              :data="detailsFrom.outCar"
              ref=""
              border
              bordersize="mini"
              style="width: 100%; margin-top: 10px"
              center
              :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
              :header-row-style="{ height: '45px' }"
              :row-style="{ height: '35px' }"
              highlight-current-row
            >
              <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
              <el-table-column prop="customerName" label="操作" width="120" align="center" >
                <template slot-scope="scope"><div>
                  <!-- 只有已完成显示历史轨迹 1已派车 2工作中 3已完成-->
                  <el-button  type="text" size="small" v-if="scope.row.task_status != '3' && btnFlg[6]" btnCode="00MP001B007">实时位置</el-button>
                  <el-button  type="text" size="small" btnCode="00MP001B008" v-if="scope.row.task_status == '3' && btnFlg[7]" @click="handleHistoryClick(scope.row)">历史轨迹</el-button>
                </div></template>
              </el-table-column>
              <el-table-column prop="task_no" label="作业单号" align="center"></el-table-column>
              <el-table-column prop="task_status_name" label="状态" align="center"></el-table-column>
              <el-table-column prop="vehicle_no" label="车号" align="center" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="fleet_name" label="车队" align="center" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="driver_name" label="司机" align="center" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="driver_mobile" label="司机电话" align="center" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="" label="派车时间" align="center" :formatter="formatterRowEmpty">
                <template slot-scope="scope"><div>
                  <span>{{scope.row.create_time | dateFormat}}</span>
                </div></template>
              </el-table-column>
              <el-table-column prop="actual_work_duration" label="工作量" align="center" :formatter="formatterRowEmpty"></el-table-column>
              <el-table-column prop="actual_start_time" label="工作开始时间" align="center" :formatter="formatterRowEmpty">
                <template slot-scope="scope"><div>
                  <span>{{scope.row.actual_start_time | dateFormat}}</span>
                </div></template>
              </el-table-column>
              <el-table-column prop="actual_end_time" label="工作结束时间" align="center" :formatter="formatterRowEmpty">
                <template slot-scope="scope"><div>
                  <span>{{scope.row.actual_end_time | dateFormat}}</span>
                </div></template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div style="width:90px;margin:15px auto;">
        <el-button type="primary" @click="detailsMark = false">关闭</el-button>
      </div>
      </el-dialog>
    </div>
    <!--实时位置，历史轨迹-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="historicalTrack"
    @close="closeDialog" @opened="openedDialog"
    width="900px"
    center>
    <div v-loading="mapLoading">
      <span>
        <div class="mapBox">
          <div class="map" id="map"></div>
        </div>
      </span>
      <div style="width:60px;margin:15px auto;">
        <el-button @click="historicalTrack = false" size='mini'>关闭</el-button>
      </div>
    </div>
    </el-dialog>
  </div>
</template>
<script>
import AMap from 'AMap'
import {
  getOrganizationByUserCode,
  getAllOrgUserTreeData, // 用车单位下拉框
  getVehicleTypeSelect, // 申请车型、单价下拉框
  getDictionaryList, // 工作类型
  VehicleapplyInfoAdd, // 新增保存
  VehicleapplyInfoUpdate, // 修改保存
  tVehicleapplyInfoList, // 查询列表
  revokeApply, // 撤销
  applyDelete, // 删除
  vhcApplyDetail, // 详情
  getVehicleMonitor, // 实时位置
  getVehicleHistory // 历史轨迹
} from '@/api/zhbPlantVehicles.js'
import { getBtn } from '@/utils/getButton'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
export default {
  data () {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /1(3|4|5|6|7|8|9)\d{9}/
        // console.log(reg.test(value))
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '00MP001B001',
        '00MP001B002',
        '00MP001B003',
        '00MP001B004',
        '00MP001B005',
        '00MP001B006',
        '00MP001B007',
        '00MP001B008'
      ],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        pageNo: 1,
        pageSize: 10,
        startTime: '',
        endTime: ''
      },
      // 工作类型
      jobTypeOptions: [],
      // 车型
      carTypeOptions: [],
      statusOptions: [],
      tableList: [],
      tabLoading: false,
      // 新增/修改
      addAndChangeMark: false,
      addAndChangeLoading: false,
      addAndChangeFrom: {
        startTime: '',
        endTime: '',
        carUnit: '', // 用车单位
        carUnitName: '', // 用车单位name
        carArea: '',
        carAreaName: '',
        applicationMode: '', // 申请车型
        applicationModeName: '', // 申请车型name
        attribute: '',
        attributeName: '',
        carNum: '', // 车数
        monovalent: '', // 单价
        monovalentName: '', // 单价拼接
        jobType: '', // 工作类型
        jobContent: '', // 工作内容
        vehicleLocation: '', // 用车地点
        vehicleOwner: '', // 用车人
        telephone: '', // 联系电话
        remarks: '', // 备注
        rowId: ''
      },
      rules: {
        startTime: [
          { required: true, message: '请选择日期', trigger: 'blur' }
        ],
        endTime: [
          { required: true, message: '请选择时间', trigger: 'blur' }
        ],
        carUnit: [
          { required: true, message: '用车单位不能为空', trigger: 'blur' }
        ],
        // carArea: [
        //   { required: true, message: '用车单位不能为空', trigger: 'blur' }
        // ],
        applicationMode: [
          { required: true, message: '申请车型不能为空', trigger: 'blur' }
        ],
        // attribute: [
        //   { required: true, message: '申请车型不能为空', trigger: 'blur' }
        // ],
        carNum: [
          { required: true, message: '请填写车数', trigger: 'blur' }
        ],
        jobType: [
          { required: true, message: '请选择工作类型', trigger: 'blur' }
        ],
        monovalent: [
          { required: true, message: '请选择单价', trigger: 'blur' }
        ],
        jobContent: [
          { required: true, message: '请填写工作内容', trigger: 'blur' }
        ],
        vehicleLocation: [
          { required: true, message: '请填写用车地点', trigger: 'blur' }
        ],
        vehicleOwner: [
          { required: true, message: '请填写用车人', trigger: 'blur' }
        ],
        telephone: [
          { required: true, validator: checkPhone, trigger: 'blur' }
        ]
      },
      carUnitOptions: [],
      carAreaOptions: [],
      attributeOptions: [],
      monovalentOptions: [],
      // 详情
      detailsMark: false,
      detailsFrom: {
        tVehicleapplyInfo: {},
        detailsTabLias: [],
        outCar: []
      },
      detailsLoading: false,
      test: {},
      vhcTypeId: '',
      tonnageModelId: '',
      isAdd: false,
      // 历史轨迹
      historicalTrack: false,
      mapLoading: false,
      marker: null,
      map: null,
      lngLat: [],
      userCodeObj: {}
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/ehicleUnit/carApplication')
    this.getDictionaryList()
    this.getDictionaryList2()
    this.getVehicleTypeSelect()
    this.getSeatchData(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 150 + 'px'
  },
  methods: {
    // 添加获取组织机构
    getOrganizationByUserCode () {
      getOrganizationByUserCode({
        userCode: localStorage.getItem('userCode')
      })
        .then((res) => {
          this.userCodeObj = JSON.parse(res)
          console.log(this.userCodeObj, 'this.userCodeObj')
          this.addAndChangeFrom.carUnit = this.userCodeObj.org.orgCode
          this.addAndChangeFrom.carUnitName = this.userCodeObj.org.orgName
          this.addAndChangeFrom.carArea = this.userCodeObj.user.orgCode // 用车单位（crm里的子部门code）
          this.addAndChangeFrom.carAreaName = this.userCodeObj.user.ext2 // 用车单位（crm里的子部门）
          this.addAndChangeFrom.vehicleOwner = this.userCodeObj.user.userName
          this.addAndChangeFrom.telephone = this.userCodeObj.user.mobile
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 验证手机
    validateMobile (mobile) {
      return /1(3|4|5|6|7|8|9)\d{9}/.test(mobile)
    },
    // 获取状态
    getDictionaryList2 () {
      getDictionaryList({
        groupNo: 'apply_flg'
      })
        .then((res) => {
          this.statusOptions = res
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    dateFormat (date) {
      let format = 'yyyy-MM-dd hh:mm:ss'
      if (date != 'Invalid Date') {
        var o = {
          'M+': date.getMonth() + 1, // month
          'd+': date.getDate(), // day
          'h+': date.getHours(), // hour
          'm+': date.getMinutes(), // minute
          's+': date.getSeconds(), // second
          'q+': Math.floor((date.getMonth() + 3) / 3), // quarter
          'S': date.getMilliseconds() // millisecond
        }
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1,
            (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (var k in o) {
          if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1,
              RegExp.$1.length == 1 ? o[k]
                : ('00' + o[k]).substr(('' + o[k]).length))
          }
        }
        return format
      }
      return ''
    },
    // 时间格式化
    timeStamp (value) { // 具体到时分秒
      var date = new Date(value) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var year = date.getFullYear()
      var month = ('0' + (date.getMonth() + 1)).slice(-2)
      var sdate = ('0' + date.getDate()).slice(-2)
      var hour = ('0' + date.getHours()).slice(-2)
      var minute = ('0' + date.getMinutes()).slice(-2)
      var second = ('0' + date.getSeconds()).slice(-2)
      // 拼接
      var result = year + '-' + month + '-' + sdate + ' ' + hour + ':' + minute + ':' + second
      // 返回
      return result
    },
    // 年月日
    timeStamp2 (value) {
      if (!value) return ''
      var now = new Date(value)
      // console.log("time:" + JSON.stringify(now));
      var year = now.getFullYear()
      var month = now.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var date = now.getDate()
      if (date < 10) {
        date = '0' + date
      }
      return year + '-' + month + '-' + date
    },
    // 创建时间
    getToDay () {
      if (this.searchFrom.startTime == '' || this.searchFrom.endTime == '') {
        this.searchFrom.startTime = ''
        this.searchFrom.endTime = ''
      } else {
        this.searchFrom.startTime = this.timeStamp(this.searchFrom.startTime)
        this.searchFrom.endTime = this.timeStamp(this.searchFrom.endTime)
      }
    },
    // 查询接口
    getSeatchData () {
      this.tabLoading = true
      tVehicleapplyInfoList(this.searchFrom)
        .then((res) => {
          this.tabLoading = false
          this.tableList = res.list
          this.total = res.total
        })
        .catch((err) => {
          this.tabLoading = false
          // console.log(err.message)
          this.$message.error(err.message)
        })
    },
    // 点击查询按钮
    searchClick () {
      // this.getToDay()
      this.getSeatchData(this.searchFrom)
    },
    // 点击重置
    chongZhiClick () {
      this.getToDay()
      this.searchFrom = {
        pageNo: 1,
        pageSize: 10,
        startTime: '',
        endTime: ''
      }
      this.getSeatchData()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getToDay()
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getToDay()
      this.getSeatchData(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row) {
      // console.log(row)
      // this.$refs.tableList.toggleRowSelection(row)
      // this.changeData = row
    },
    handleTabCurrentChange (val) {
      // this.currentRow = val
    },
    // 点击添加
    addBtnClick () {
      this.addAndChangeMark = true
      this.title = '添加'
      this.isAdd = true
      this.getOrganizationByUserCode()
    },
    // 获取用车单位下拉框
    getAllOrgUserTreeData () {
      getAllOrgUserTreeData()
        .then((res) => {
          this.test = JSON.parse(res)
          this.carUnitOptions = this.test.children
          console.log(this.test, 'this.test')
          for (let index = 0; index < this.carUnitOptions.length; index++) {
            let element = this.carUnitOptions[index]
            console.log(element, 'element')
            if (element.orgCode == this.addAndChangeFrom.carUnit) {
              this.carAreaOptions = element.children
              this.addAndChangeFrom.carUnitName = element.orgName
              return
            }
          }
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 用车单位值改变时
    carUnitChange (item) {
      // console.log(item,'item')
      if (item != null && item != undefined && item != '') {
        this.addAndChangeFrom.carArea = ''
        for (let index = 0; index < this.carUnitOptions.length; index++) {
          let element = this.carUnitOptions[index]
          console.log(element, 'element')
          if (element.orgCode == item) {
            this.carAreaOptions = element.children
            this.addAndChangeFrom.carUnitName = element.orgName
            return
          }
        }
      }
    },
    carAreaChange (val) {
      this.carAreaOptions.forEach((item, index) => {
        if (item.orgCode == val) {
          this.addAndChangeFrom.carAreaName = item.orgName
        }
      })
    },
    // 申请车型、单价下拉框
    getVehicleTypeSelect () {
      getVehicleTypeSelect()
        .then((res) => {
          this.carTypeOptions = res
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 申请车型第一个下拉框改变时
    applicationModeChange (val) {
      this.addAndChangeFrom.attribute = ''
      this.addAndChangeFrom.monovalent = ''
      this.monovalentOptions = []
      this.attributeOptions = []
      this.vhcTypeId = val
      this.carTypeOptions.forEach((item, index) => {
        if (item.vhcTypeId == val) {
          this.addAndChangeFrom.applicationModeName = item.vhcTypeName
        }
      })
      getVehicleTypeSelect({
        vhcTypeId: this.vhcTypeId
      })
        .then((res) => {
          res.forEach((item, index) => {
            if (item.tonnageModelId == null || item.tonnageModelId == '' || item.tonnageModelId == undefined) {
              this.attributeOptions = []
              this.addAndChangeFrom.attribute = ''
              this.addAndChangeFrom.attributeName = ''
              // this.addAndChangeFrom.attribute = '--'
              getVehicleTypeSelect({
                vhcTypeId: this.vhcTypeId,
                tonnageModelId: '-1'
              })
                .then((res) => {
                  this.monovalentOptions = res
                  this.addAndChangeFrom.monovalent = this.monovalentOptions[0].unitPrice + '/' + this.monovalentOptions[0].pricingMethodName
                })
                .catch((err) => {
                  this.$message.error(err.message)
                })

              // this.monovalentOptions = res
            } else {
              this.attributeOptions = res
            }
          })
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    attributeChange (val) {
      this.addAndChangeFrom.monovalent = ''
      this.monovalentOptions = []
      this.tonnageModelId = val
      this.attributeOptions.forEach((item, index) => {
        if (item.tonnageModelId == val) {
          this.addAndChangeFrom.attributeName = item.tonnageModel
        }
      })
      if (this.tonnageModelId != null || this.tonnageModelId != '' || this.tonnageModelId != undefined) {
        getVehicleTypeSelect({
          vhcTypeId: this.vhcTypeId,
          tonnageModelId: this.tonnageModelId
        })
          .then((res) => {
            this.monovalentOptions = res
            this.addAndChangeFrom.monovalent = this.monovalentOptions[0].unitPrice + '/' + this.monovalentOptions[0].pricingMethodName
          })
          .catch((err) => {
            this.$message.error(err.message)
          })
      }
    },
    // 单价下拉框值改变
    monovalentChange (val) {
      console.log(val, 'val')
      this.addAndChangeFrom.monovalentName = val
      // this.monovalentOptions.forEach((item,index) =>{
      //   if(this.addAndChangeFrom.monovalent == val){
      //     this.addAndChangeFrom.monovalentName = item.unitPrice + '/' + item.pricingMethod
      //     // this.addAndChangeFrom.monovalent = item.unitPrice
      //   }
      // })
    },
    // 获取工作类型下拉框
    getDictionaryList () {
      getDictionaryList({
        groupNo: 'work_type'
      })
        .then((res) => {
          this.jobTypeOptions = res
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
    // 点击修改
    changeDataClick (row) {
      this.addAndChangeMark = true
      this.title = '修改'
      this.isAdd = false
      this.getOrganizationByUserCode()
      this.$nextTick(() => {
        // this.addAndChangeFrom.monovalent = row.unit_price + '/' + row.pricing_method
        this.$set(this.addAndChangeFrom, 'monovalent', row.unit_price + '/' + row.pricing_method)
        this.$set(this.addAndChangeFrom, 'carNum', row.vhc_num)
        this.$set(this.addAndChangeFrom, 'attribute', row.tonnage_model_id)
        this.$set(this.addAndChangeFrom, 'attributeName', row.tonnage_model)
        this.$set(this.addAndChangeFrom, 'applicationMode', row.vhc_type_id)
        this.$set(this.addAndChangeFrom, 'applicationModeName', row.vhc_type_name)
        // this.$set(this.addAndChangeFrom, 'carArea', row.subsidiary_department_code)
        // this.$set(this.addAndChangeFrom, 'carAreaName', row.subsidiary_department_name)
        // this.$set(this.addAndChangeFrom, 'carUnit', row.department_code)
        this.$set(this.addAndChangeFrom, 'jobType', row.work_type)
        this.$set(this.addAndChangeFrom, 'jobContent', row.work_content)
        this.$set(this.addAndChangeFrom, 'vehicleLocation', row.vhcapply_address)
        // this.$set(this.addAndChangeFrom, 'vehicleOwner', row.apply_user)
        this.$set(this.addAndChangeFrom, 'startTime', row.apply_start_time)
        this.$set(this.addAndChangeFrom, 'endTime', row.apply_end_time)
        // this.$set(this.addAndChangeFrom, 'telephone', row.user_mobile)
        this.$set(this.addAndChangeFrom, 'remarks', row.remark)
        this.$set(this.addAndChangeFrom, 'rowId', row.id)
        getVehicleTypeSelect({
          vhcTypeId: this.addAndChangeFrom.applicationMode
        })
          .then((res) => {
            res.forEach((item, index) => {
              if (item.tonnageModelId == null || item.tonnageModelId == '' || item.tonnageModelId == undefined) {
                this.attributeOptions = [] // 申请车型第二个下拉框
                this.addAndChangeFrom.attribute = ''
                this.addAndChangeFrom.attributeName = ''
                // this.addAndChangeFrom.attribute = '--'
                this.monovalentOptions = res // 单价
                // this.addAndChangeFrom.monovalent = this.monovalentOptions[0].unitPrice + '/' + this.monovalentOptions[0].pricingMethodName
              } else {
                this.attributeOptions = res
                getVehicleTypeSelect({
                  vhcTypeId: this.addAndChangeFrom.applicationMode,
                  tonnageModelId: this.addAndChangeFrom.attribute
                })
                  .then((res) => {
                    this.monovalentOptions = res
                    // this.addAndChangeFrom.monovalent = this.monovalentOptions[0].unitPrice + '/' + this.monovalentOptions[0].pricingMethodName
                  })
                  .catch((err) => {
                    this.$message.error(err.message)
                  })
              }
            })
          })
          .catch((err) => {
            this.$message.error(err.message)
          })
      })
    },
    // 点击撤销
    revokeClick (row) {
      this.$confirm('是否确定此操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      })
        .then(() => {
          this.tabLoading = true
          applyDelete({
            id: row.id
          })
            .then(res => {
              this.tabLoading = false
              this.$message.success('删除成功！')
              this.getSeatchData(this.searchFrom)
            })
            .catch(err => {
              this.tabLoading = false
              this.$message.error(err.message)
            })
        })
        .catch(() => {})
    },
    // 点击详情
    detailsClick (row) {
      this.detailsMark = true
      this.title = '详情'
      this.detailsLoading = true
      vhcApplyDetail({
        id: row.id
      })
        .then(res => {
          this.detailsLoading = false
          this.detailsFrom = res
          if (res.tVehicleapplyInfo != null || res.tVehicleapplyInfo != undefined) {
            this.detailsFrom.tVehicleapplyInfo = res.tVehicleapplyInfo
          }
          if (res.tFleetDistributionList.length != 0) {
            this.detailsFrom.detailsTabLias = res.tFleetDistributionList
          } else {
            this.detailsFrom.detailsTabLias = []
          }
          if (res.tVheicleTaskList.length != 0) {
            this.detailsFrom.outCar = res.tVheicleTaskList
          } else {
            this.detailsFrom.outCar = []
          }
        })
        .catch(err => {
          this.detailsLoading = false
          this.$message.error(err.message)
        })
    },
    // 点击提交
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            // 开始时间-当前时间  小于等于20抛错误信息
            var date = new Date().getTime()
            if ((this.addAndChangeFrom.startTime).getTime() - date <= 1200000) {
              this.$message.error('开始时间不能小于当前时间20分钟')
            } else {
              this.addAndChangeLoading = true
              VehicleapplyInfoAdd({
                applyNo: '', // 申请编号
                applyStartTime: this.timeStamp(this.addAndChangeFrom.startTime), // 申请用车时间开始
                applyEndTime: this.timeStamp(this.addAndChangeFrom.endTime), // 申请用车时间结束
                departmentCode: this.addAndChangeFrom.carUnit, // 用车单位(crm里的部门code)
                departmentName: this.addAndChangeFrom.carUnitName, // 用车单位（crm里的部门）
                subsidiaryDepartmentCode: this.addAndChangeFrom.carArea, // 用车单位（crm里的子部门code）
                subsidiaryDepartmentName: this.addAndChangeFrom.carAreaName, // 用车单位（crm里的子部门）
                vhcTypeId: this.addAndChangeFrom.applicationMode, // 申请车型(车型单价表中车辆类型ID)
                vhcTypeName: this.addAndChangeFrom.applicationModeName, // 申请车型名称
                tonnageModelId: this.addAndChangeFrom.attribute, // 车型参数（车型单价表吨位/机型Id）
                tonnageModel: this.addAndChangeFrom.attributeName, // 车型参数
                vhcNum: this.addAndChangeFrom.carNum, // 车数
                unitPrice: '', // 单价
                applyFlg: '', // 申请状态
                workType: this.addAndChangeFrom.jobType, // 工作类型(字典表work_type)
                workContent: this.addAndChangeFrom.jobContent, // 工作内容
                vhcapplyAddress: this.addAndChangeFrom.vehicleLocation, // 用车地点
                applyUser: this.addAndChangeFrom.vehicleOwner, // 用车人
                userMobile: this.addAndChangeFrom.telephone, // 联系电话
                remark: this.addAndChangeFrom.remarks, // 备注
                pricingMethod: this.addAndChangeFrom.monovalent // 计价方式
              })
                .then((res) => {
                  this.addAndChangeLoading = false
                  this.addAndChangeMark = false
                  this.$message.success('添加成功！')
                  this.$refs[formName].resetFields()
                  this.getSeatchData(this.searchFrom)
                })
                .catch((err) => {
                  this.addAndChangeLoading = false
                  this.$message.error(err.message)
                })
            }
          } else {
            // 开始时间-当前时间  小于等于20抛错误信息
            var date = new Date().getTime()
            if (this.addAndChangeFrom.startTime - date <= 1200000) {
              this.$message.error('开始时间不能小于当前时间20分钟')
            } else {
              this.addAndChangeLoading = true
              VehicleapplyInfoUpdate({
                id: this.addAndChangeFrom.rowId,
                applyNo: '', // 申请编号
                applyStartTime: this.timeStamp(this.addAndChangeFrom.startTime), // 申请用车时间开始
                applyEndTime: this.timeStamp(this.addAndChangeFrom.endTime), // 申请用车时间结束
                departmentCode: this.addAndChangeFrom.carUnit, // 用车单位(crm里的部门code)
                departmentName: this.addAndChangeFrom.carUnitName, // 用车单位（crm里的部门）
                subsidiaryDepartmentCode: this.addAndChangeFrom.carArea, // 用车单位（crm里的子部门code）
                subsidiaryDepartmentName: this.addAndChangeFrom.carAreaName, // 用车单位（crm里的子部门）
                vhcTypeId: this.addAndChangeFrom.applicationMode, // 申请车型(车型单价表中车辆类型ID)
                vhcTypeName: this.addAndChangeFrom.applicationModeName, // 申请车型名称
                tonnageModelId: this.addAndChangeFrom.attribute, // 车型参数（车型单价表吨位/机型Id）
                tonnageModel: this.addAndChangeFrom.attributeName, // 车型参数
                vhcNum: this.addAndChangeFrom.carNum, // 车数
                unitPrice: '', // 单价
                applyFlg: '', // 申请状态
                workType: this.addAndChangeFrom.jobType, // 工作类型(字典表work_type)
                workContent: this.addAndChangeFrom.jobContent, // 工作内容
                vhcapplyAddress: this.addAndChangeFrom.vehicleLocation, // 用车地点
                applyUser: this.addAndChangeFrom.vehicleOwner, // 用车人
                userMobile: this.addAndChangeFrom.telephone, // 联系电话
                remark: this.addAndChangeFrom.remarks, // 备注
                pricingMethod: this.addAndChangeFrom.monovalent // 计价方式
              })
                .then((res) => {
                  this.addAndChangeLoading = false
                  this.addAndChangeMark = false
                  this.$message.success('修改成功！')
                  this.$refs[formName].resetFields()
                  this.getSeatchData(this.searchFrom)
                })
                .catch((err) => {
                  this.addAndChangeLoading = false
                  this.$message.error(err.message)
                })
            }
          }
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 点击取消
    resetForm (formName) {
      this.$refs[formName].resetFields()
      this.addAndChangeMark = false
    },
    addCloseDialog (formName) {
      this.$refs[formName].resetFields()
      // this.addAndChangeMark = false
    },
    // 点击详情关闭
    handleClose (done) {
      this.detailsMark = false
    },
    // 点击历史轨迹
    handleHistoryClick (row) {
      this.title = '历史轨迹'
      this.historicalTrack = true
      this.mapLoading = true
      getVehicleHistory({
        id: row.id
      }).then(res => {
        this.mapLoading = false
        this.lngLat = res
        this.polylineFn()
      }).catch(err => {
        this.mapLoading = false
        this.$message.error(err.message)
      })
    },
    polylineFn () {
      if (this.marker) {
        this.map.clearMap()
      }
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.lngLat[0],
        icon: new AMap.Icon({
          image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/zhbcps/Applets/qi.png',
          size: new AMap.Size(30, 30), // 图标大小
          imageSize: new AMap.Size(30, 30),
          offset: new AMap.Pixel(-10, -34)
        }),
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      this.marker = new AMap.Marker({
        map: this.map,
        position: this.lngLat[this.lngLat.length - 1],
        icon: new AMap.Icon({
          image: 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/zhbcps/Applets/zhong.png',
          size: new AMap.Size(30, 30), // 图标大小
          imageSize: new AMap.Size(30, 30),
          offset: new AMap.Pixel(-10, -34)
        }),
        offset: new AMap.Pixel(-26, -13),
        autoRotation: true,
        cellValue: -90
      })
      var passedPolyline = new AMap.Polyline({
        map: this.map,
        path: this.lngLat,
        strokeColor: '#2d70e4', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 3, // 线宽
        strokeStyle: 'solid' // 线样式
      })
      this.marker.on('moving', function (e) {
        passedPolyline.setPath(e.passedPath)
      })
      this.map.setFitView()
    },
    // 历史轨迹打开弹框
    openedDialog () {
      this.initMap()
      // this.polylineFn()
    },
    closeDialog () {
    },
    // 地图
    initMap () {
      this.map = new AMap.Map('map', {
        center: [116.397428, 39.90923], // [纬度，经度]
        resizeEnable: true,
        zoom: 12
      })
    }
  }
}
</script>
<style scoped lang='less'>
.el-table {
  overflow: visible !important;
}
.searchBox {
  margin-left: 25px;
}
.inpBox {
  margin: 10px 0 0 -30px;
}
.searchBtnBox {
  margin-top: 10px;
  margin-left: -20px;
}
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}
.tongJi {
  display: flex;
  margin-left: 10px;
  margin-bottom: 20px;
}
.tongJi_item {
  margin-right: 20px;
}
.tongJi_item span {
  color: red;
}
.mapBox{
  width: 100%;
  height: 560px;
  position: relative;
}
</style>
